export default {
  id: 'shell',
  title: 'Navigation, dialogs and account (admin)',
  note: 'The app shell every signed-in screen sits inside: sidebar and top bar, the shared modal, and the mandatory password-change gate.',
  texts: {
    // Sidebar — brand and product switcher
    'nav.brand.alt': 'HiTrail',
    'nav.brand.sub': 'MAS',
    'nav.brand.tag': 'Mobility Accounting',
    'nav.product.title': 'MAS — Mobility Accounting Service',
    'nav.product.abbr': 'MA',
    'nav.product.name': 'MAS',
    'nav.product.subOperator': 'Operator console',
    'nav.product.subCarrier': 'Carrier portal',

    // Sidebar — group headings
    'nav.group.operations': 'Operations',
    'nav.group.workspace': 'Workspace',
    'nav.group.account': 'Account',

    // Sidebar — navigation items
    'nav.dashboard': 'Dashboard',
    'nav.companies': 'Companies',
    'nav.partnerships': 'Partnerships',
    'nav.transactions': 'Transactions',
    'nav.reports': 'G6 Reports',
    'nav.users': 'Users',
    'nav.analytics': 'Analytics',
    'nav.settings': 'Settings',
    'nav.apiReference': 'API reference',

    // Sidebar — account footer. The two suffixes are appended to the company
    // name, so the leading separator and spaces belong to the text.
    'nav.signOut': 'Sign out',
    'nav.foot.operatorSuffix': ' · Operator',
    'nav.foot.carrierSuffix': ' · Carrier',

    // Sidebar — version badge. The uptime prefix is concatenated with the
    // value reported by the backend, so it keeps its trailing space.
    'nav.version.title': 'Frontend bundle + backend instance versions',
    'nav.version.fe': 'FE',
    'nav.version.be': 'BE',
    'nav.version.build': 'build',
    'nav.version.uptimePrefix': 'up ',

    // Top bar
    'nav.topbar.operator': 'Operator',
    'nav.topbar.carrier': 'Carrier',
    'nav.topbar.companyRics': 'RICS {rics} · {country}',
    'nav.topbar.notifications': 'Notifications',
    'nav.topbar.settings': 'Settings',
    'nav.search.placeholderOperator': 'Find company, agreement, tx ID…',
    'nav.search.placeholderCarrier': 'Find transaction, report…',

    // Shared modal
    'modal.close': 'Close',

    // Mandatory password change
    'changePassword.heading': 'Change your password',
    'changePassword.sub': 'Your account requires a password change before you can continue.',
    'changePassword.field.current': 'Current password',
    'changePassword.field.new': 'New password',
    'changePassword.field.confirm': 'Confirm new password',
    'changePassword.submit': 'Set new password',
    'changePassword.submitBusy': 'Saving…',
    'changePassword.logout': 'Log out instead',
    'changePassword.error.mismatch': 'New passwords do not match.',
    'changePassword.error.tooShort': 'New password must be at least 8 characters.',
    'changePassword.error.failed': 'Failed to change password.',
  },
}
